export const listbookings = {
    // Check-in de una estancia vendida por horas: los campos mínimos
    rapido: "سريع",
  text1: "مرحبًا بك!",
  text2: "قائمة تسجيلات الوصول، أدِرها أو أرسل رابطًا لتسجيل نزلائك.",
  text3: "قائمة تسجيلات الوصول",
  text4: "تصدير",
  text5: "تسجيل وصول جديد",
  text6: "الكل",
  text7: "قيد الانتظار",
  text8: "مكتمل",
  text9: "اليوم",
  text10: "الهاتف",
  text11: "الاسم",
  text12: "رقم الهوية",
  text13: "الدولة",
  text14: "تسجيل الوصول",
  text15: "المفاتيح",
  text16: "مُسلَّمة",
  text17: "بالانتظار",
  text18: "عرض المعلومات الكاملة",
  text19: "مستند موقّع",
  text20: "الكل",
  text21: "حدث خطأ في عملية تأكيد التسليم",
  text22: "معلومات تسجيل الوصول",
  text23: "البيانات المجمّعة عند تسجيل وصول النزيل",
  text24: "الاسم الأول",
  text25: "اسم العائلة",
  text26: "الهاتف",
  text27: "تاريخ الإقامة",
  text28: "نوع المستند",
  text29: "جواز سفر",
  text30: "بطاقة الهوية الوطنية",
  text31: "رقم المستند",
  text32: "تاريخ انتهاء المستند",
  text33: "الجنسية",
  text34: "تاريخ الميلاد",
  text35: "الجنس",
  text36: "أنثى",
  text37: "ذكر",
  text38: "اكتب هنا ...",
  text39:
    "مرحبًا [guest_name]،\nأهلًا بك في HOTEL BARCELO MALAGA!\n\nشكرًا جزيلًا لإقامتك معنا، نودّ إبلاغك بأن وقت تسجيل المغادرة حتى الساعة 10:00 صباحًا.\n\nكما نوافيك ببيانات الدخول إلى شبكة Wifi لدينا:\n\nالشبكة: HOTEL-BARCELO\nكلمة المرور: xkamakj1a0\n\n\nنأمل أن تكون إقامتك ممتعة قدر الإمكان.\n\nنحن في خدمتك في الاستقبال على مدار 24 ساعة.\n\nتحياتنا!",
  text40: "اسم وحدة إقامتك مطلوب.",
  text41: "سياسات وحدة الإقامة مطلوبة.",
  text42: "يجب تضمين رسالة ترحيب.",
  text43: "تم حفظ التغييرات بنجاح",
  text44: "خطأ في الطلب",
  text45: "تم التسجيل بنجاح.",
  text46: "😃 مرحبًا!! ",
  text47:
    " لقد أكملت بنجاح إنشاء وحدة إقامتك الأولى، ويمكنك الآن مشاركة رمز QR ليقوم المستخدمون بـ ",
  text48: "تسجيل الوصول",
  text49: "تلقائيًا 👍",
  text50: "يمكنك تعديل الحقول التي أدخلتها سابقًا من قائمة",
  text51: "إعدادات النموذج.",
  text52: "تنزيل",
  text53: "متابعة",
  text54: "معلومات تسجيل الوصول.",
  text55: "بيانات تسجيل الوصول",
  text56: "تاريخ الطلب:",
  text57: " في",
  text58: "البيانات المجمّعة عند تسجيل وصول النزيل",
  text59: "الاسم",
  text60: "اسم العائلة",
  text61: "الهاتف",
  text62: "تاريخ الإقامة",
  text63: "نوع المستند",
  text64: "جواز سفر",
  text65: "بطاقة الهوية الوطنية",
  text66: "رقم المستند",
  text67: "معلومات إضافية",
  text68: "تاريخ انتهاء المستند",
  text69: "الجنسية",
  text70: "تاريخ الميلاد",
  text71: "الجنس",
  text72: "أنثى",
  text73: "ذكر",
  text74: "إغلاق",
  text75: "تسجيل وصول جديد",
  text76:
    "يمكنك إرسال الرابط أو إنشاء تسجيل وصول يدوي عبر الخيارات التالية.",
  text77: "تسجيل الوصول",
  text78: "تسجيل وصول يدوي من لوحة التحكم.",
  text79: "إرسال تسجيل الوصول",
  text80: "رابط الحجز إلى نزيل.",
  text81: "جارٍ التحميل، يُرجى الانتظار...",
  text82: "سنوات",
  text83: "أيام",

  // Modal exportar
  text84: `تصدير`,
  text85: `تصدير التقارير في WACheckin`,
  text86: `تنزيل تقرير تسجيلات الوصول`,
  text87: `نزّل تسجيلات الوصول التي أجراها نزلاؤك واحصل على
    تقرير مفصّل يتضمن معلومات مثل تاريخ تسجيل الوصول، وغير
    ذلك من البيانات.`,
  text88: `تنزيل تقرير الهجرة`,
  text89: `في حال فشلت المزامنة التلقائية مع جهة الهجرة
    يمكنك تنزيل هذا التقرير وإدخال بيانات نزيلك
    يدويًا.`,

  text90: `المفاتيح المُسلَّمة`,
  text91: `الجهات المختصة`,
  text92: `تنزيل تقرير الشرطة`,
  text93: `حذف تسجيل الوصول`,
  text94: `لا يوجد نزلاء مسجّلون في وحدة إقامتك بعد`,
  text95: `سيظهر هنا النزلاء المسجّلون`,
  text96: `تصدير`,
  text97: `تصدير`,
  text98: `تصدير`,

  // Corrections

  p1: `إرسال`,
  p2: `رابط تسجيل الوصول`,
  p3: `مسح`,
  p4: `سيوقّع النزيل على هذا الجهاز`,
  p5: `ممسوح`,
  p6: `يدوي`,
  p7: `مشغّل يدوي`,
  p8: `تسجيلات الوصول`,
  p9: `استخدم خيار تسجيل الوصول اليدوي لتسجيل نزلائك مباشرة من الاستقبال`,
  p10: `تسجيل وصول يدوي`,
  p11: `أرسل رابط تسجيل الوصول عبر الإنترنت إلى نزلائك عبر WhatsApp أو البريد الإلكتروني لتسهيل تسجيلهم قبل وصولهم`,
  p12: `إرسال تسجيل الوصول عبر الإنترنت`,
  p13: `غير محدّد`,
  p14: `حذف تسجيل الوصول`,
  p15: `هل أنت متأكد من حذف تسجيل الوصول؟ لن تتمكن من استرداد البيانات المحذوفة`,
  p16: `حذف`,
  p17: `إلغاء`,
  p18: `أطلق الإمكانات الكاملة مع مزايانا المتقدمة`,
  p19: `تسجيل وصول تلقائي عبر WhatsApp`,
  p20: `إرسال مستندات المسافرين`,
  p21: `التحقق من الهوية`,
  p22: `تقييم تلقائي`,
  p23: `البيع المتقاطع`,
  p24: `إدارة مفاتيح النزلاء`,
  p25: `فوترة النزلاء`,
  p26: `لا تفوّت المزايا!`,
  p27: `الترقية إلى Premium`,

  p28: `البند`,
  p29: `رسوم إضافية`,
  p30: `الحالة`,
  p31: `مدفوع`,
  p32: `قيد الانتظار`,
  p33: `مُسترَد`,
  p34: `استرداد الرسوم`,
  p35: `استرداد`,
  p36: `هل أنت متأكد من استرداد الرسوم إلى النزيل؟`,
  p37: `وثيقة الهوية`,
  p38: `جواز سفر`,
  p39:`تصفية`,
  p40:`تسجيلات الوصول المكتملة`,
  p41:`تسجيلات الوصول الجارية`,
  p42: `ليس لديك تسجيلات وصول جارية`,
  p43: `معلومات تسجيل الوصول`,
  p44: `تسجيلات الوصول المرتبطة`,
  p45: `لا توجد تسجيلات وصول مرتبطة.`,
  p46: `مزيد من المعلومات:`,
  p47: `تاريخ تسجيل الوصول:`,
  p48: `تاريخ تسجيل المغادرة:`,

  p49:`نزيل`,
  p50:`نزلاء`,
  

};
